import validate from "/Users/darsh/Development/workspace-public-website/node_modules/.pnpm/nuxt@3.9.1_eslint@8.56.0_sass@1.70.0_typescript@5.3.3_vue-tsc@1.8.27/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/darsh/Development/workspace-public-website/node_modules/.pnpm/nuxt@3.9.1_eslint@8.56.0_sass@1.70.0_typescript@5.3.3_vue-tsc@1.8.27/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}